import React from 'react';
import CatalogueFieldList from '../../forms/components/CatalogueFieldList';
import Selectors from '../hooks/selectors';

const DatasetCatalogueTabList = ({
  category,
  children,
  code,
  direction,
  index = 0,
  panel,
  section,
  url,
}) => {
  const { hasChildren } = Selectors.useDatasetCatalogueAccordionFieldList({
    category, code, section, panel, index, url,
  });
  return (
    <CatalogueFieldList code={code} category={category} direction={direction} section={section}>
      {hasChildren && (<>{children}</>)}
    </CatalogueFieldList>
  );
};

export default DatasetCatalogueTabList;
